var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconElectronicsIntegratedCircuit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 8.25h3m-3 3.75h3m-3 3.75h3m10.5-7.5h3m-3 3.75h3m-3 3.75h3m-10.5-12v-3m4.5 3v-3m-4.5 22.5v-3m4.5 3v-3m-7.5-16.5h10.5v16.5H6.75Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconElectronicsIntegratedCircuit);
export default __webpack_public_path__ + "static/media/streamline-icon-electronics-integrated-circuit.b00b8e8a.svg";
export { ForwardRef as ReactComponent };